const navMenu = [{
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    requiredGroup: "all"
  },

  // {
  //   url: null,
  //   name: "Comercial",
  //   slug: "Comercial",
  //   icon: "FileIcon",
  //   requiredGroup: "all",
  //   submenu: [{
  //       url: "/pedidos",
  //       name: "Pedidos",
  //       slug: "Pedidos",
  //       icon: "FileIcon",
  //       requiredGroup: "all"
  //     },
  //     {
  //       url: "/orcamentos",
  //       name: "Orçamentos",
  //       slug: "Orçamentos",
  //       requiredGroup: "all"
  //     },
  //     {
  //       url: "/necessidadeDePecas",
  //       name: "Necessidade de Peças",
  //       slug: "Necessidade de Peças",
  //       requiredGroup: "all"
  //     },
  //     // {
  //     //   url: "/ordens-de-compra",
  //     //   name: "Ordens de Compra",
  //     //   slug: "Ordens de Compra",
  //     //   requiredGroup: "all"
  //     // },
  //   ],
  // },

  // {
  //   url: null,
  //   name: "Cadastro",
  //   slug: "Cadastro",
  //   icon: "FileIcon",
  //   requiredGroup: "all",
  //   submenu: [{
  //       url: "/clientes",
  //       name: "Clientes",
  //       slug: "Clientes",
  //       requiredGroup: "all"
  //     },
  //     {
  //       url: "/fornecedores",
  //       name: "Fornecedores",
  //       slug: "Fornecedores",
  //       requiredGroup: "all"
  //     },
  //     {
  //       url: "/produtos",
  //       name: "Produtos",
  //       slug: "produtos",
  //       requiredGroup: "all"
  //     },
  //     {
  //       url: "/produtos/estoque",
  //       name: "Estoque",
  //       slug: "estoque",
  //       requiredGroup: "all"
  //     },
  //     {
  //       url: "/transportadoras",
  //       name: "Transportadoras",
  //       slug: "Transportadoras",
  //       requiredGroup: "all"
  //     },
  //   ],
  // },

  // {
  //   url: null,
  //   name: "Financeiro",
  //   slug: "Financeiro",
  //   icon: "DollarSignIcon",
  //   requiredGroup: "all",
  //   submenu: [{
  //     url: "/faturamento",
  //     name: "Faturamento",
  //     slug: "Faturamento",
  //     requiredGroup: "financeiro"
  //   }],
  // },

  // {
  //   url: null,
  //   name: "Tarefas",
  //   icon: "HomeIcon",
  //   requiredGroup: "all",
  //   submenu: [{
  //       url: "/tarefas/aprovacaoComercial",
  //       name: "Aprovação Comercial",
  //       slug: "Aprovação Comercial",
  //       requiredGroup: "representante"
  //     },
  //     {
  //       url: "/tarefas/aprovacaoFinanceira",
  //       name: "Aprovação Financeira",
  //       slug: "Aprovação Financeira",
  //       requiredGroup: "financeiro"
  //     },
  //     {
  //       url: "/tarefas/faturamento",
  //       name: "Faturamento",
  //       slug: "Faturamento",
  //       requiredGroup: "financeiro"
  //     },
  //     {
  //       url: "/tarefas/expedicao",
  //       name: "Expedição",
  //       slug: "Expedição",
  //       requiredGroup: "estoquista",
  //       isDisabled: true
  //     },
  //   ]
  // },

  // {
  //   url: null,
  //   name: "Relatorios",
  //   slug: "relatorios",
  //   icon: "DownloadIcon",
  //   requiredGroup: "all",
  //   submenu: [{
  //       url: "/relatorios/estoque",
  //       name: "Estoque",
  //       slug: "Estoque",
  //       requiredGroup: "all"
  //     },
  //     {
  //       url: "/relatorios/vendas",
  //       name: "Vendas",
  //       slug: "vendas",
  //       requiredGroup: "all"
  //     }
  //   ],
  // },

  {
    url: null,
    name: "Importação",
    slug: "Importação",
    icon: "PackageIcon",
    requiredGroup: "all",
    submenu: [{
        url: "/importacoes",
        name: "Visualizar",
        slug: "Importações",
        requiredGroup: "all"
      },
      {
        url: "/importacoes/descricoes",
        name: "Descrições",
        slug: "Descrições",
        requiredGroup: "all"
      },
    ],
  },

  // {
  //   url: "/marketing",
  //   name: "Marketing",
  //   slug: "Marketing",
  //   icon: "MailIcon",
  //   requiredGroup: "all"
  // },

  {
    url: "/impressao",
    name: "Impressão",
    slug: "Impressão",
    icon: "PrinterIcon",
    requiredGroup: "all"
  },

  {
    url: "/qr-code",
    name: "QR Code",
    slug: "QR Code",
    icon: 'qr_code',
    featherIcon: false,
    size: '1.45rem',
    requiredGroup: "all"
  },
]

export default navMenu